import axios, { AxiosResponse } from 'axios';
import { Acreditado, AcreditadoAuthRequest, Campo } from './suite.interfaces';
import { CommonService } from './common.services';

export class SuiteService extends CommonService {

  async saveOrUpdate(evento:number, acreditado:Acreditado): Promise<Acreditado> {
    try {
      const acreditados = { "acreditados": [  acreditado ]};
      const response: AxiosResponse<Acreditado[]> = await axios.post(this.getServerUrl() + '/mobile/update?evento=' + evento, acreditados, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data[0] as Acreditado;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async saveOrUpdateAll(evento:number, acreditados:Acreditado[]): Promise<Acreditado[]> {
    try {
      const acreditadosList = {"acreditados": acreditados };
      const response: AxiosResponse<Acreditado[]> = await axios.post(this.getServerUrl() + '/mobile/update?evento=' + evento, acreditadosList, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async auth(evento:number, username: string, passwd: string, method:number): Promise<String> {
    try {
      const authRequest: AcreditadoAuthRequest = {} as AcreditadoAuthRequest;
      authRequest.username = username;
      authRequest.password = passwd;
      authRequest.method = method;

      const response: AxiosResponse<String> = await axios.post(this.getServerUrl() + '/mobile/auth?evento=' + evento, authRequest, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async changePassword(evento: number, hash: string, currentPasswd: string, newPasswd: string): Promise<boolean> {
    try {
      const authRequest: AcreditadoAuthRequest = {} as AcreditadoAuthRequest;
      authRequest.password = currentPasswd;
      authRequest.newPassword = newPasswd;

      const response: AxiosResponse<String> = await axios.post(this.getServerUrl() + '/mobile/changePassword?evento=' + evento + '&hash=' + hash, authRequest, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return (response.data as string == "Ok");
      
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findAcreditadoByDni(evento:number, dni: string): Promise<Acreditado> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&dni=' + dni, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data[0];
    } catch (error) {
      throw this.manageError(error);    }
  }

  async findAcreditadoByHash(evento:number, hash: string): Promise<Acreditado> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&hash=' + hash, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data[0];
    } catch (error) {
      throw this.manageError(error);    }
  }

  async findAcreditadoByFilters(evento:number, parameters: string): Promise<Acreditado> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data[0];
    } catch (error) {
      throw this.manageError(error);    }
  }

  async findAcreditadosByFilters(evento:number, parameters: string): Promise<Acreditado[]> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    }
  }

  async findAcreditadosBy(evento:number, parameters: string): Promise<Acreditado[]> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async findAcreditadosByEvento(evento:number): Promise<Acreditado[]> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async findCampoBy(evento:number, campo:number): Promise<Campo> {
    try {
      const response: AxiosResponse<Campo> = await axios.get(this.getServerUrl() + '/mobile/findCampoBy?evento=' + evento + "&idCampo=" + campo, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async findCantidadBy(evento:number) : Promise<number> {
    try {
      const response: AxiosResponse<number> = await axios.get(this.getServerUrl() + '/mobile/findCantidadBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

    async findCantidadEstadoAcreditadoBy(evento:number, estadoAcreditado:number) : Promise<number> {
    try {
      const response: AxiosResponse<number> = await axios.get(this.getServerUrl() + '/mobile/findCantidadEstadoAcreditadoBy?evento=' + evento + '&estado=' + estadoAcreditado, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async findCantidadByFilters(evento:number, parameters: string) : Promise<number> {
    try {
      const response: AxiosResponse<number> = await axios.get(this.getServerUrl() + '/mobile/findCantidadByFilters?evento=' + evento + "&" + parameters, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async findLecturasBy(evento:number, modulo:number) {
    return axios.get(this.getServerUrl() + '/accesos/findLecturasBy?evento=' + evento + "&modulo=" + modulo, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
  }

  async notificar(evento:number, idAcreditado:number, mailNotificacion:string) {
    try {
      const response: AxiosResponse<number> = await axios.get(this.getServerUrl() + '/mobile/notificar?evento=' + evento + "&acreditado=" + idAcreditado + "&mailNotificacion=" + mailNotificacion, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }
  
  async findAcreditadosByEmpresa(evento:number, empresa:number): Promise<Acreditado[]> {
    try {
      const response: AxiosResponse<Acreditado[]> = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByEmpresa?evento=' + evento + '&empresa=' + empresa, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);    
    }
  }

  async sendAccesoMeeting(evento:number, mail:string, dni:string): Promise<boolean> {
    try {
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/mobile/sendAccesoMeeting?evento=' + evento + '&mail=' + mail + '&dni=' + dni, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data == "OK";
    } catch (error) {
      throw this.manageError(error);    
    }
  }


}

